import React, { useEffect, useState } from "react";
import Select from "../../components/select/Select";
import "./VirtualSubForm.css";

const VirtualSubForm = (props) => {
  useEffect(() => {}, [props]);

  const [coordinates] = useState(["x1", "y1", "x2", "y2"]);

  // const [graphicStyles] = useState([
  //   { key: "outerLineColor", title: "Outer Line Color" },
  //   { key: "lineSize", title: "Line Size" },
  //   { key: "fillColor", title: "Fill Color" },
  // ]);

  const [indexNums] = useState([{ key: "1" }, { key: "2" }, { key: "3" }]);

  //props.addGraphOrAction(["exerciseSteps", i, "successActions"])

  return (
    <div className="virtual_hold">
      <div className="vth_title">
        {props.addType === "onScreenGraphics" ? "Draw Graphic" : props.addType === "singleActions" ? "Actions" : ""}
      </div>
      {props.addType === "onScreenGraphics" && props.virtualState.exerciseSteps[0][props.addType]
        ? props.virtualState.exerciseSteps[0][props.addType].map((item, j) =>
            props.addType === "onScreenGraphics" ? (
              <div className="vt_step_hold">
                <div className="vt_select_hold vts_block">
                  <Select
                    placeholder="Graphic Type"
                    initVal={
                      item.graphicType === "line"
                        ? "Line"
                        : item.graphicType === "image"
                        ? "Image"
                        : item.graphicType === "circle"
                        ? "Circle"
                        : item.graphicType === "floorCircle"
                        ? "Floor Circle"
                        : item.graphicType === "animatedCircle"
                        ? "Animated Circle"
                        : ""
                    }
                    selectOptions={[
                      { value: "Line" },
                      { value: "Image" },
                      { value: "Circle" },
                      { value: "Floor Circle" },
                      { value: "Animated Circle" },
                    ]}
                    selectCallback={props.handleArrSubVals}
                    callBackValue={["exerciseSteps", props.stepModified, "onScreenGraphics", j, "graphicType"]}
                  />
                </div>
                {item.graphicType === "image" && (
                  <div className="vt_inp_included select_main">
                    <div className="select_placeholder sp_act">Image URL</div>
                    <input
                      type="text"
                      value={item.imageUrl ? item.imageUrl : ""}
                      onChange={(e) =>
                        props.handleGraphicType([props.stepModified, j, "imageUrl"], e.currentTarget.value)
                      }
                    />
                  </div>
                )}
                <div className="vt_select_hold vts_block"></div>
                {coordinates.map((coo, i) => (
                  <div className="vt_coordinates_hold">
                    <div className="vt_select_hold">
                      <Select
                        placeholder="Point Type"
                        initVal={
                          item.graphicData[coo].start[0] === "mediaPoint"
                            ? "Media Pipe Point"
                            : item.graphicData[coo].start[0] === "pixel"
                            ? "Pixel"
                            : item.graphicData[coo].start[0] === "screenPercent"
                            ? "Screen Percent"
                            : ""
                        }
                        selectOptions={[{ value: "Media Pipe Point" }, { value: "Pixel" }, { value: "Screen Percent" }]}
                        selectCallback={props.handleGraphicPoints}
                        callBackValue={[props.stepModified, j, coo, "start", 0]}
                      />
                    </div>
                    {item.graphicData[coo].start !== undefined &&
                      (item.graphicData[coo].start[0] === "mediaPoint" ? (
                        <div className="vt_select_hold vt_mpipe_s_short">
                          <Select
                            initVal={
                              props.mediaPipePoints[item.graphicData[coo].start[1] ? item.graphicData[coo].start[1] : 0]
                                .value
                            }
                            placeholder={coo}
                            selectOptions={props.mediaPipePoints}
                            selectCallback={props.handleGraphicPoints}
                            callBackValue={[props.stepModified, j, coo, "start", 1]}
                          />
                        </div>
                      ) : (
                        <div key={i} className="vt_coordinates vt_inp_included select_main">
                          <div className="select_placeholder sp_act">{coo}</div>
                          <input
                            type="text"
                            value={
                              props.virtualState.exerciseSteps[props.stepModified].onScreenGraphics[j].graphicData[coo]
                                .start[1]
                            }
                            onChange={(e) =>
                              props.handleGraphicPoints([props.stepModified, j, coo, "start", 1], e.currentTarget.value)
                            }
                          />
                        </div>
                      ))}
                    <div className="vt_select_hold vts_block">
                      <Select
                        placeholder="Offset Type"
                        initVal={
                          item.graphicData[coo].offset === undefined
                            ? ""
                            : item.graphicData[coo].offset[0] === "mediaPipeLength"
                            ? "Media Pipe Length"
                            : item.graphicData[coo].offset[0] === "pixel"
                            ? "Pixel"
                            : item.graphicData[coo].offset[0] === "screenPercent"
                            ? "Screen Percent"
                            : ""
                        }
                        selectOptions={[
                          { value: "Media Pipe Length" },
                          { value: "Pixel" },
                          { value: "Screen Percent" },
                        ]}
                        selectCallback={props.handleGraphicPoints}
                        callBackValue={[props.stepModified, j, coo, "offset", 0]}
                      />
                    </div>
                    {item.graphicData[coo].offset !== undefined &&
                      (item.graphicData[coo].offset[0] === "mediaPipeLength" ? (
                        <>
                          <div className="vt_select_hold vt_mpipe_s_short">
                            <Select
                              initVal={item.graphicData[coo].offset[1] ? item.graphicData[coo].offset[1] : "x"}
                              placeholder={coo}
                              selectOptions={[{ value: "x" }, { value: "y" }]}
                              selectCallback={props.handleGraphicPoints}
                              callBackValue={[props.stepModified, j, coo, "offset", 1]}
                            />
                          </div>
                          <div className="vt_select_hold vt_mpipe_s_short">
                            <Select
                              initVal={
                                props.mediaPipePoints[
                                  item.graphicData[coo].offset[2] ? item.graphicData[coo].offset[2] : 0
                                ].value
                              }
                              placeholder={coo}
                              selectOptions={props.mediaPipePoints}
                              selectCallback={props.handleGraphicPoints}
                              callBackValue={[props.stepModified, j, coo, "offset", 2]}
                            />
                          </div>
                          <div className="vt_select_hold vt_mpipe_s_short">
                            <Select
                              initVal={
                                props.mediaPipePoints[
                                  item.graphicData[coo].offset[3] ? item.graphicData[coo].offset[3] : 0
                                ].value
                              }
                              placeholder={coo}
                              selectOptions={props.mediaPipePoints}
                              selectCallback={props.handleGraphicPoints}
                              callBackValue={[props.stepModified, j, coo, "offset", 3]}
                            />
                          </div>
                          <div className="vt_coordinates vt_inp_included select_main">
                            <div className="select_placeholder sp_act">Multiply</div>
                            <input
                              type="number"
                              value={item.graphicData[coo].offset ? item.graphicData[coo].offset[4] : ""}
                              onChange={(e) =>
                                props.handleGraphicPoints(
                                  [props.stepModified, j, coo, "offset", 4],
                                  e.currentTarget.value
                                )
                              }
                            />
                          </div>
                        </>
                      ) : (
                        <div className="vt_coordinates vt_inp_included select_main">
                          <div className="select_placeholder sp_act">Offset</div>
                          <input
                            type="text"
                            value={item.graphicData[coo].offset ? item.graphicData[coo].offset[1] : ""}
                            onChange={(e) =>
                              props.handleGraphicPoints(
                                [props.stepModified, j, coo, "offset", 1],
                                e.currentTarget.value
                              )
                            }
                          />
                        </div>
                      ))}
                  </div>
                ))}
                {
                  <div
                    className="e_create_input vt_inp_included select_main"
                    style={{ border: "none", display: "block" }}
                  >
                    Graphic Style
                  </div>
                }
                {item.graphicType === "line" ? (
                  <>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">Inner Color</div>
                      <input
                        type="text"
                        value={item.graphicData.innerColor ? item.graphicData.innerColor : ""}
                        onChange={(e) =>
                          props.handleGraphicType([props.stepModified, j, "innerColor"], e.currentTarget.value)
                        }
                      />
                    </div>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">Inner Size</div>
                      <input
                        type="text"
                        value={item.graphicData.innerSize ? item.graphicData.innerSize : ""}
                        onChange={(e) =>
                          props.handleGraphicType([props.stepModified, j, "innerSize"], e.currentTarget.value, true)
                        }
                      />
                    </div>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">Outer Color</div>
                      <input
                        type="text"
                        value={item.graphicData.outerColor ? item.graphicData.outerColor : ""}
                        onChange={(e) =>
                          props.handleGraphicType([props.stepModified, j, "outerColor"], e.currentTarget.value)
                        }
                      />
                    </div>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">Outer Size</div>
                      <input
                        type="text"
                        value={item.graphicData.outerSize ? item.graphicData.outerSize : ""}
                        onChange={(e) =>
                          props.handleGraphicType([props.stepModified, j, "outerSize"], e.currentTarget.value, true)
                        }
                      />
                    </div>
                  </>
                ) : (
                  (item.graphicType === "floorCircle" ||
                    item.graphicType === "animatedCircle" ||
                    item.graphicType === "circle") && (
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">Color</div>
                      <input
                        type="text"
                        value={item.graphicData.color ? item.graphicData.color : ""}
                        onChange={(e) =>
                          props.handleGraphicType([props.stepModified, j, "color"], e.currentTarget.value)
                        }
                      />
                    </div>
                  )
                )}
              </div>
            ) : (
              ""
            )
          )
        : props.addType === "singleActions" &&
          props.virtualState.exerciseSteps[0].positionDetect[props.stepModified][props.addType].map((item, j) =>
            props.addType === "singleActions" ? (
              <div className="vt_step_hold">
                <div className="vt_select_hold vts_block">
                  <Select
                    placeholder="Action Type"
                    initVal={
                      item.action /* === "counter"
                  ? "Counter"
                  : item.action */ === "playAudio"
                        ? "Play Audio"
                        : item.action === "changeVariable"
                        ? "Change Variable"
                        : item.action === "changeStep"
                        ? "Change Step"
                        : item.action === "repIncrease"
                        ? "Rep Increase"
                        : item.action === "changeObject"
                        ? "Change Object"
                        : item.action === "changeMainObject"
                        ? "Change Main Object"
                        : item.action === "changeGraphic"
                        ? "Change Graphic"
                        : item.action === "showCircleAnimation"
                        ? "Show Circle Animation"
                        : ""
                    }
                    selectOptions={[
                      /* { value: "Counter" }, */
                      { value: "Play Audio" },
                      { value: "Change Variable" },
                      { value: "Change Step" },
                      { value: "Rep Increase" },
                      { value: "Change Object" },
                      { value: "Change Main Object" },
                      { value: "Change Graphic" },
                      { value: "Show Circle Animation" },
                    ]}
                    selectCallback={props.handleArrSubVals}
                    callBackValue={["exerciseSteps", props.stepModified, "singleActions", j, "action"]}
                  />
                </div>
                {item.action === "changeVariable" ? (
                  <>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">Variable Name</div>
                      <input
                        type="text"
                        value={item.item}
                        onChange={(e) =>
                          props.handleArrSubVals(
                            ["exerciseSteps", props.stepModified, "singleActions", j, "item"],
                            e.currentTarget.value
                          )
                        }
                      />
                    </div>
                    {item.item !== "currentStep" && item.item !== "minimumLevel" ? (
                      <div className="vt_select_hold">
                        <Select
                          placeholder="Value"
                          initVal={
                            item.value === true ? "True" : item.value === false ? "False" : item.value ? item.value : ""
                          }
                          selectOptions={
                            item.item === "detectType"
                              ? [{ value: "Target Position" }, { value: "Position Detect" }]
                              : item.item === "detectAny"
                              ? [{ value: "True" }, { value: "False" }]
                              : item.item.length > 0
                              ? [
                                  { value: "True" },
                                  { value: "False" },
                                  { value: "0" },
                                  { value: "1" },
                                  { value: "2" },
                                  { value: "3" },
                                  { value: "4" },
                                  { value: "5" },
                                ]
                              : ""
                          }
                          selectCallback={props.handleArrSubVals}
                          callBackValue={["exerciseSteps", props.stepModified, "singleActions", j, "value", "dropDown"]}
                        />
                      </div>
                    ) : (
                      <div className="vt_inp_included select_main">
                        <div className="select_placeholder sp_act">Value</div>
                        <input
                          type="text"
                          value={item.value}
                          onChange={(e) =>
                            props.handleArrSubVals(
                              ["exerciseSteps", props.stepModified, "singleActions", j, "value"],
                              e.currentTarget.value
                            )
                          }
                        />
                      </div>
                    )}
                  </>
                ) : item.action === "playAudio" ? (
                  <div>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">Play Audio</div>
                      <input
                        type="text"
                        value={item.value}
                        onChange={(e) =>
                          props.handleArrSubVals(
                            ["exerciseSteps", props.stepModified, "singleActions", j, "value"],
                            e.currentTarget.value
                          )
                        }
                      />
                    </div>
                  </div>
                ) : item.action === "changeStep" || item.action === "repIncrease" ? (
                  <div className="vt_inp_included select_main">
                    <div className="select_placeholder sp_act">
                      {item.action === "changeStep" ? "Change Step" : "Rep Increase"}
                    </div>
                    <input
                      type="number"
                      value={item.value}
                      onChange={(e) =>
                        props.handleArrSubVals(
                          ["exerciseSteps", props.stepModified, "singleActions", j, "value"],
                          parseInt(e.currentTarget.value)
                        )
                      }
                    />
                  </div>
                ) : item.action === "counter" || item.action === "changeObject" ? (
                  <>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">
                        {item.action === "counter" ? "Counter" : "Change Object"}
                      </div>
                      <input
                        type="text"
                        value={item.item}
                        onChange={(e) =>
                          props.handleArrSubVals(
                            ["exerciseSteps", props.stepModified, "singleActions", j, "item"],
                            e.currentTarget.value
                          )
                        }
                      />
                    </div>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">Value</div>
                      <input
                        type="text"
                        value={item.value}
                        onChange={(e) =>
                          props.handleArrSubVals(
                            ["exerciseSteps", props.stepModified, "singleActions", j, "value"],
                            e.currentTarget.value,
                            item.action === "counter" ? true : ""
                          )
                        }
                      />
                    </div>
                  </>
                ) : item.action === "changeMainObject" ? (
                  <>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">Sub Object</div>
                      <input
                        type="text"
                        value={item.subObject}
                        onChange={(e) =>
                          props.handleActionObjectNodes([props.stepModified, j, "subObject"], e.currentTarget.value)
                        }
                      />
                    </div>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">itemIndex</div>
                      <input
                        type="number"
                        value={item.itemIndex}
                        onChange={(e) =>
                          props.handleActionObjectNodes(
                            [props.stepModified, j, "itemIndex"],
                            parseInt(e.currentTarget.value)
                          )
                        }
                      />
                    </div>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">index2</div>
                      <input
                        type="number"
                        value={item.index2}
                        onChange={(e) =>
                          props.handleActionObjectNodes(
                            [props.stepModified, j, "index2"],
                            parseInt(e.currentTarget.value)
                          )
                        }
                      />
                    </div>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">index4</div>
                      <input
                        type="text"
                        value={item.index4}
                        onChange={(e) =>
                          props.handleActionObjectNodes([props.stepModified, j, "index4"], e.currentTarget.value)
                        }
                      />
                    </div>
                    {item.subObject === "exerciseSteps" && (
                      <>
                        <div className="vt_inp_included select_main">
                          <div className="select_placeholder sp_act">Item Index</div>
                          <input
                            type="text"
                            value={item.itemIndex}
                            onChange={(e) =>
                              props.handleArrSubVals(
                                ["exerciseSteps", props.stepModified, "singleActions", j, "itemIndex"],
                                e.currentTarget.value,
                                true
                              )
                            }
                          />
                        </div>
                        <div className="vt_inp_included select_main">
                          <div className="select_placeholder sp_act">Index 1</div>
                          <input
                            type="text"
                            value={item.index1}
                            onChange={(e) =>
                              props.handleActionObjectNodes([props.stepModified, j, "index1"], e.currentTarget.value)
                            }
                          />
                        </div>
                        {(item.index1 === "positionDetect" || item.index1 === "onScreenGraphics") && (
                          <>
                            <div className="vt_inp_included select_main">
                              <div className="select_placeholder sp_act">Index 2</div>
                              <input
                                type="text"
                                value={item.index2}
                                onChange={(e) =>
                                  props.handleArrSubVals(
                                    ["exerciseSteps", props.stepModified, "singleActions", j, "index2"],
                                    e.currentTarget.value,
                                    true
                                  )
                                }
                              />
                            </div>
                            <div className="vt_inp_included select_main">
                              <div className="select_placeholder sp_act">Index 3</div>
                              <input
                                type="text"
                                value={item.index3}
                                onChange={(e) =>
                                  props.handleActionObjectNodes(
                                    [props.stepModified, j, "index3"],
                                    e.currentTarget.value
                                  )
                                }
                              />
                            </div>
                            {(item.index3 === "detectPoints" || item.index3 === "graphicData") && (
                              <div className="vt_inp_included select_main">
                                <div className="select_placeholder sp_act">Index 4</div>
                                <input
                                  type="text"
                                  value={item.index4}
                                  onChange={(e) =>
                                    props.handleArrSubVals(
                                      ["exerciseSteps", props.stepModified, "singleActions", j, "index4"],
                                      e.currentTarget.value
                                    )
                                  }
                                />
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">Value</div>
                      <input
                        type="text"
                        value={item.value}
                        onChange={(e) =>
                          props.handleArrSubVals(
                            ["exerciseSteps", props.stepModified, "singleActions", j, "value"],
                            e.currentTarget.value
                          )
                        }
                      />
                    </div>
                  </>
                ) : item.action === "changeGraphic" ? (
                  <>
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">Item Index</div>
                      <input
                        type="text"
                        value={item.itemIndex}
                        onChange={(e) =>
                          props.handleArrSubVals(
                            ["exerciseSteps", props.stepModified, "singleActions", j, "itemIndex"],
                            e.currentTarget.value,
                            true
                          )
                        }
                      />
                    </div>
                    {indexNums.map((inx, inxNum) => (
                      <div key={inxNum} className="vt_inp_included select_main">
                        <div className="select_placeholder sp_act">{"Index " + inx.key}</div>
                        <input
                          type="text"
                          value={item["index" + inx.key]}
                          onChange={(e) =>
                            props.handleArrSubVals(
                              ["exerciseSteps", props.stepModified, "singleActions", j, "index" + inx.key],
                              e.currentTarget.value
                            )
                          }
                        />
                      </div>
                    ))}
                    <div className="vt_inp_included select_main">
                      <div className="select_placeholder sp_act">Value</div>
                      <input
                        type="text"
                        value={item.value}
                        onChange={(e) =>
                          props.handleArrSubVals(
                            ["exerciseSteps", props.stepModified, "singleActions", j, "value"],
                            e.currentTarget.value
                          )
                        }
                      />
                    </div>
                  </>
                ) : item.action === "showCircleAnimation" ? (
                  <div className="vt_inp_included select_main">
                    <div className="select_placeholder sp_act">Value</div>
                    <input
                      type="text"
                      value={item.value}
                      onChange={(e) =>
                        props.handleArrSubVals(
                          ["exerciseSteps", props.stepModified, "singleActions", j, "value"],
                          parseInt(e.currentTarget.value)
                        )
                      }
                    />
                  </div>
                ) : (
                  ""
                )}
                {/* <div className="vt_inp_included select_main">
            <div className="select_placeholder sp_act">Delay (in seconds)</div>
            <input
              type="text"
              value={item.delayAction}
              onChange={(e) =>
                props.handleArrSubVals(
                  ["exerciseSteps", props.stepModified, "singleActions", j, "delayAction"],
                  e.currentTarget.value,
                  true
                )
              }
            />
          </div> */}
                <div
                  className="vt_add vt_inp_del_act"
                  onClick={() => props.handleActionObjectNodes([props.stepModified, j, "deleteAction"], true)}
                >
                  Delete Action
                </div>
              </div>
            ) : (
              ""
            )
          )}

      {props.addType === "onScreenGraphics" ? (
        <div
          className="vt_add"
          onClick={() => props.addGraphOrAction(["exerciseSteps", props.stepModified, "onScreenGraphics"])}
        >
          Add Graphic
        </div>
      ) : (
        <div
          className="vt_add"
          onClick={() =>
            props.addGraphOrAction(["exerciseSteps", props.stepModified, "singleActions", "positionDetect"])
          }
        >
          Add Action
        </div>
      )}
    </div>
  );
};

export default VirtualSubForm;
